import { useCallback } from "react";

import { Alert } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import Loader from "../../../common/components/Loader";
import GroupForm from "../components/GroupForm";
import { IGroup } from "../interfaces/group";
import { getGroup } from "../services";

const GroupContainter = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation<{
    readOnly: boolean;
  }>();
  const readOnly = location.state?.readOnly ?? false;

  const { data, isLoading, error } = useQuery<IGroup, Error>(
    ["group_management", id],
    () => getGroup(id),
    {
      enabled: !!id,
    }
  );

  // force rerender form with new data
  const UpdateFormRender = useCallback(
    () => <GroupForm defaultValues={data} readOnly={readOnly} />,
    [data, readOnly]
  );

  if (!id) {
    return <GroupForm />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    console.log(`Error Fetch Groupe id => ${id} :`, error.message);
    return (
      <Alert variant="danger">
        Impossible de récupérer les informations du groups.&nbsp;Veuiller
        contacter votre administrateur système.
      </Alert>
    );
  }

  if (!data) {
    return (
      <Alert variant="danger">
        Erreur de récupération des données : Veuillez réessayer ultérieurement.
      </Alert>
    );
  }

  return <UpdateFormRender />;
};

export default GroupContainter;
